import { Button, DialogContainer, Slider } from '@components'
import { CheckCheck, Star } from 'lucide-solid'
import { createEffect, createSignal } from 'solid-js'
import { useService } from 'solid-services'
import { Grid } from 'styled-system/jsx'
import { useSingle } from '../../state'
import Action from './Action'

export const Score = () => {
	const [isOpen, setIsOpen] = createSignal(false)
	const [score, setScore] = createSignal<number>()
	const { isArchived, setScore: saveScore, takenResource } = useService(useSingle)()

	const handleScore = () => {
		const s = score()
		if (s) {
			saveScore(s)
		}
	}

	createEffect(() => {
		if (takenResource.state === 'ready') {
			setIsOpen(false)
		}
	})

	return (
		<>
			<Action
				heading="Score"
				text="Score this setup"
				active={false}
				disabled={isArchived()}
				onClick={() => setIsOpen(true)}
				icon={<CheckCheck />}
			/>
			<DialogContainer
				title="Score"
				description="Give this setup a score out of 10"
				isOpen={isOpen()}
				setIsOpen={setIsOpen}
			>
				<Grid
					p={8}
					gap={8}
				>
					<Slider
						step={1}
						max={10}
						defaultValue={[takenResource()?.score || 0]}
						marks={[
							{ value: 0, label: '0' },
							{ value: 1, label: '1' },
							{ value: 2, label: '2' },
							{ value: 3, label: '3' },
							{ value: 4, label: '4' },
							{ value: 5, label: '5' },
							{ value: 6, label: '6' },
							{ value: 7, label: '7' },
							{ value: 8, label: '8' },
							{ value: 9, label: '9' },
							{ value: 10, label: '10' },
						]}
						onValueChange={({ value }) => setScore(value[0])}
					/>

					<Grid
						gridTemplateColumns="1fr 1fr"
						gap={4}
						mt={4}
					>
						<Button
							onClick={() => setIsOpen(false)}
							variant="outline"
						>
							Cancel
						</Button>
						<Button
							loading={takenResource.loading}
							colorPalette="tscGreen"
							variant="solid"
							onClick={handleScore}
						>
							Confirm
						</Button>
					</Grid>
				</Grid>
			</DialogContainer>
		</>
	)
}
